<template>
  <v-flex xs6 sm4 md3 lg2 class="inline-block pa-4">
    <v-card style="text-align: center" class="pa-2" :class="{ 'tile-loading': loading }" ripple @click="fetchNbRequest">
      <v-icon color="#444" size="100">mdi-radar</v-icon>
      <v-card-title style="justify-content: center; align-items: center">
        <span>{{ $t('Admin.AisQuery.MenuTitle') }} :</span>
        <v-progress-circular v-if="loading" indeterminate size="20" width="2" color="primary" class="ml-2" />
        <span v-else class="ml-2 font-weight-bold">{{ displayValue }}</span>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import apiMission from '@/api/mission'
import { directQuery } from '@/utils/api'
import { IrisrawModAisRoot } from '@/models/iris/IrisrawModAisRoot'

@Component({
  name: 'AisQueryTile',
})
export default class AisQueryTile extends Vue {
  loading = false
  nbRequest: number | null = null

  get displayValue(): string {
    return this.nbRequest == null ? '—' : String(this.nbRequest)
  }

  mounted() {
    this.fetchNbRequest()
  }

  fetchNbRequest() {
    if (this.loading) return
    this.loading = true
    directQuery<IrisrawModAisRoot>(apiMission.getAisRootConfig)
      .then(mod => {
        this.nbRequest = mod?.data?.mod_settings?.AIS?.nb_request ?? null
      })
      .catch(() => {
        this.nbRequest = null
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<style scoped>
.tile-loading {
  opacity: 0.7;
  cursor: progress;
}
</style>
